import { action, makeObservable, observable } from 'mobx';
import { isSSR } from '@/core';

export class GoogleRecaptchaStore {
  @observable
  public isEnabled = !isSSR();

  @observable
  public siteKey = RCAPW.googleRecaptchaKey;

  constructor() {
    makeObservable(this);
  }

  @action.bound
  setIsEnabled(value: boolean): void {
    this.isEnabled = value;
  }

  @action.bound
  setSiteKey(value: string): void {
    this.siteKey = value;
  }
}
